export const GIFTING_IMAGE = {
    IMAGE_ID: "portal/static-assets/images/gifting-cart/Coupons_popup.png",
    WIDTH: "300px",
    HEIGHT: "210px",
};

export const SPARKLE_ICON = {
    ALT: "sparkle-icon",
    IMAGE_ID: "portal/static-assets/icons/gifting-cart/sparkle-filled-primary.png",
    WIDTH: "12px",
    HEIGHT: "12px",
};
